import firebase from "firebase/app";
import "firebase/storage"

var firebaseConfig = {
    apiKey: "AIzaSyDnCWRk8fQghOanT5JUeLPG3JMWAmIe9Vo",
    authDomain: "vhenga-site.firebaseapp.com",
    projectId: "vhenga-site",
    storageBucket: "vhenga-site.appspot.com",
    messagingSenderId: "583640391529",
    appId: "1:583640391529:web:6f1a15dad9b4b8492ca7f8",
    measurementId: "G-EM3LMMSE1F"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

var storage = firebase.storage();

export {firebase, storage};